import { Builder } from '@builder.io/react'
import { faChevronDown, faChevronUp, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Disclosure, Transition } from '@headlessui/react'
import { internationalPhoneNumber, localPhoneNumberReadable } from 'constants/phone'
import { HeadingClass, HeadingType } from 'enums'
import React from 'react'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'
interface Faq {
  question: string
  answer: string
  answerCustom: string
  answerCustomTwo: string
  displayTable: boolean
}

enum FAQIcon {
  Plus = 'plus',
  Arrow = 'arrow'
}
interface Props {
  faqs: Faq[]
  backgroundColor: string
  headingText: string
  headingTextColor: string
  FaqsQuestionBackgroundColor: string
  faqQuestionColor: string
  FaqsAnswerBackgroundColor: string
  faqAnswerColor: string
  PlusMinusBackgroundColor: string
  PlusMinusColor: string
  headingType: HeadingType
  headingClass: HeadingClass
  contactFaq: boolean
  faqIcon: FAQIcon
}

const FAQAlternate = ({
  faqs,
  backgroundColor,
  headingText,
  headingTextColor,
  FaqsQuestionBackgroundColor,
  faqQuestionColor,
  FaqsAnswerBackgroundColor,
  faqAnswerColor,
  PlusMinusBackgroundColor,
  PlusMinusColor,
  headingType,
  headingClass,
  contactFaq,
  faqIcon = 'plus'
}: Props) => {
  const renderTable = () => {
    // Hard coded due to cell borders not displaying when map rendering (tailwind/builder issue?)
    return (
      <div className="center w-11/12  my-2 border border-[#6BA2B3] rounded-xl overflow-hidden">
        <table className="w-full text-center border-collapse border border-[#6BA2B3] rounded-xl overflow-hidden">
          <tr>
            <th className="border border-[#6BA2B3] bg-white w-1/3">Dog size</th>
            <th className="border border-[#6BA2B3] bg-[#FFF8F2] w-1/3">Gram per day</th>
            <th className="border border-[#6BA2B3] bg-white w-1/3">Cost per day</th>
          </tr>
          <tr>
            <th className="border border-[#6BA2B3] bg-white font-medium">Under 10 kg</th>
            <th className="border border-[#6BA2B3] bg-[#FFF8F2] font-medium">160 - 250g</th>
            <th className="border border-[#6BA2B3] bg-white font-medium">From £0.42</th>
          </tr>
          <tr>
            <th className="border border-[#6BA2B3] bg-white font-medium">10 - 25 kg</th>
            <th className="border border-[#6BA2B3] bg-[#FFF8F2] font-medium">400 - 500g</th>
            <th className="border border-[#6BA2B3] bg-white font-medium">From £0.85</th>
          </tr>
          <tr>
            <th className="border border-[#6BA2B3] bg-white font-medium">Over 25 kg</th>
            <th className="border border-[#6BA2B3] bg-[#FFF8F2] font-medium">650g</th>
            <th className="border border-[#6BA2B3] bg-white font-medium">From £1.14</th>
          </tr>
        </table>
      </div>
    )
  }

  return (
    <div className="bg-gray-50 pt-4 pb-10" style={{ backgroundColor: backgroundColor || 'transparent' }}>
      <div className="mx-auto max-w-7xl py-0 sm:py-0 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <CustomHeading
            classList="text-center pb-2"
            headingClass={headingClass}
            headingType={headingType}
            color={headingTextColor || '#000000'}
          >
            {headingText}
          </CustomHeading>
          <dl className="flex flex-col gap-y-4 px-4 lg:px-0">
            {faqs?.map((faq, i) => (
              <Disclosure as="div" key={i}>
                {({ open }) => (
                  <>
                    <dt className="relative rounded-full p-2 text-lg" style={{ backgroundColor: '#B0CDD5', zIndex: 1 }}>
                      <Disclosure.Button className={`flex w-full items-center justify-between text-left text-primary`}>
                        <span
                          className={`ml-2 ${open ? 'font-bold' : ''} text-sm text-primary lg:text-base `}
                          style={{ color: faqQuestionColor }}
                        >
                          {faq.question}
                        </span>

                        <span
                          className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full ${faqIcon === 'plus' ? 'bg-primary' : ''}`}
                        >
                          {!open && (
                            <FontAwesomeIcon
                              icon={faqIcon === 'arrow' ? faChevronDown : faPlus}
                              className={`h-6 w-6 transform ${faqIcon === 'plus' ? 'text-white' : 'text-[#006685]'} `}
                              aria-hidden="true"
                            />
                          )}
                          {open && (
                            <FontAwesomeIcon
                              icon={faqIcon === 'arrow' ? faChevronUp : faMinus}
                              className={`h-6 w-6 transform ${faqIcon === 'plus' ? 'text-white' : 'text-[#006685]'} `}
                              aria-hidden="true"
                            />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Transition
                      enter="transition duration-100 ease-out"
                      enterFrom="transform scale-55 opacity-0"
                      enterTo="transform scale-100 opacity-100"
                      leave="transition duration-75 ease-out"
                      leaveFrom="transform scale-100 opacity-100"
                      leaveTo="transform scale-55 opacity-0"
                      className={'-mb-6'}
                    >
                      <Disclosure.Panel
                        as="dd"
                        className={`relative -top-8 rounded-b-3xl bg-[#B0CDD5] p-4 pt-8`}
                        style={{ zIndex: 0 }}
                      >
                        {faq.answerCustom ? (
                          <div dangerouslySetInnerHTML={{ __html: faq.answerCustom }} />
                        ) : (
                          <p className="text-sm text-primary lg:text-base" style={{ color: faqAnswerColor }}>
                            {faq.answer}
                          </p>
                        )}
                        {faq.displayTable && renderTable()}
                        {faq.answerCustomTwo && <div dangerouslySetInnerHTML={{ __html: faq.answerCustomTwo }} />}
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
          {contactFaq && (
            <dl className="flex flex-col gap-y-4 px-4 lg:px-0 mt-4">
              <Disclosure as="div" key={'contact'}>
                {({ open }) => (
                  <>
                    <dt className="relative rounded-full p-2 text-lg" style={{ backgroundColor: '#B0CDD5', zIndex: 1 }}>
                      <Disclosure.Button className={`flex w-full items-center justify-between text-left text-primary`}>
                        <span
                          className={`ml-2 ${open ? 'font-bold' : ''} text-sm text-primary lg:text-base `}
                          style={{ color: faqQuestionColor }}
                        >
                          How can I get in touch if I have more questions?
                        </span>

                        <span
                          className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primary`}
                        >
                          {!open && (
                            <FontAwesomeIcon
                              icon={faqIcon === 'arrow' ? faChevronDown : faPlus}
                              className={`h-6 w-6 transform ${faqIcon === 'plus' ? 'text-white' : 'text-[#006685]'} `}
                              aria-hidden="true"
                            />
                          )}
                          {open && (
                            <FontAwesomeIcon
                              icon={faqIcon === 'arrow' ? faChevronUp : faMinus}
                              className={`h-6 w-6 transform ${faqIcon === 'plus' ? 'text-white' : 'text-[#006685]'} `}
                              aria-hidden="true"
                            />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Transition
                      enter="transition duration-100 ease-out"
                      enterFrom="transform scale-55 opacity-0"
                      enterTo="transform scale-100 opacity-100"
                      leave="transition duration-75 ease-out"
                      leaveFrom="transform scale-100 opacity-100"
                      leaveTo="transform scale-55 opacity-0"
                      className={'-mb-6'}
                    >
                      <Disclosure.Panel
                        as="dd"
                        className={`relative -top-8 rounded-b-3xl bg-[#B0CDD5] p-4 pt-8`}
                        style={{ zIndex: 0 }}
                      >
                        <p className="text-sm text-primary lg:text-base" style={{ color: faqAnswerColor }}>
                          If you have any more questions about our recipes, subscription service or your dog's needs
                          please do not hesitate to contact our wonderful Customer Delight team, who love nothing more
                          than talking about dogs all day! Send us an email at{' '}
                          <a className="font-bold" href="mailto:feedme@differentdog.com">
                            feedme@differentdog.com
                          </a>{' '}
                          or give us a call on{' '}
                          <a className="font-bold" href={`tel:${internationalPhoneNumber}`}>
                            {localPhoneNumberReadable}
                          </a>{' '}
                          .
                        </p>
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            </dl>
          )}
        </div>
      </div>
    </div>
  )
}

export default FAQAlternate

Builder.registerComponent(FAQAlternate, {
  name: 'FAQAlternate',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'transparent'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'FAQs'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'FaqsQuestionBackgroundColor',
      type: 'color',
      defaultValue: '#6BA1B3'
    },
    {
      name: 'faqQuestionColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'FaqsAnswerBackgroundColor',
      type: 'color',
      defaultValue: '#C0D1D6'
    },
    {
      name: 'faqAnswerColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'PlusMinusBackgroundColor',
      type: 'color',
      defaultValue: '#036685'
    },
    {
      name: 'PlusMinusColor',
      type: 'color',
      defaultValue: '#ffffff'
    },
    {
      name: 'faqs',
      type: 'list',
      defaultValue: [{ question: 'Whats the best food that we can get?', answer: 'Dog food' }],
      subFields: [
        { name: 'question', type: 'string', defaultValue: 'Whats the best food that we can get?' },
        { name: 'answer', type: 'string', defaultValue: 'Dog food' },
        {
          name: 'answerCustom',
          type: 'richText',
          defaultValue: ''
        },
        {
          name: 'answerCustomTwo',
          type: 'richText',
          defaultValue: ''
        },
        {
          name: 'displayTable',
          type: 'boolean',
          defaultValue: false
        }
      ]
    },
    {
      name: 'contactFaq',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'faqIcon',
      type: 'string',
      enum: ['plus', 'arrow'],
      defaultValue: 'plus'
    }
  ]
})
